<template>
  <div class="i-css-left">
    <div v-if="referencedDocuments.length" class="references">
      <span v-for="(doc, idx) in referencedDocuments" :key="idx">
        <a :href="infoUrl(doc)"
           class="block_link" title="Document info"
           target="blank" :aria-label="LANG.opensBlank">
           <strong :title="title(doc)">{{title(doc)}}</strong>
        </a>
        <br>
        <label class="oce_label" :title="link(doc)">{{link(doc)}}</label>
        <br>
      </span>
    </div>
    <div v-if="!referencedDocuments.length">
      {{ LANG.noReferences }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import globals from '@/globals';

const { uri } = globals.I.Util;

export default defineComponent({
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
    referencedDocuments() {
      if (!this.item) return [];
      return this.item.finished.from;
    },
  },
  methods: {
    title(doc) {
      return doc.copies[0].title || '[Untitled]';
    },
    link(doc) {
      return doc.copies[0].link;
    },
    nodeId(doc) {
      return doc.copies[0].node_id;
    },
    version(doc) {
      return doc.copies[0].version;
    },
    infoUrl(doc) {
      return uri(`/document/oce/info?__imperia_node_id=${this.nodeId(doc)}`);
    },
  },
});
</script>

<style scoped lang='scss'>
a {
  color: $link-color;
}
</style>
